export default function FeaturesSection() {
  const features = [
    {
      icon: 'ri-flashlight-line',
      title: 'Velocidad Extrema',
      description: 'Accede a millones de archivos en milisegundos con nuestro motor de indexación avanzado',
      gradient: 'from-yellow-400 to-orange-500',
      bgColor: 'bg-gradient-to-r from-yellow-50 to-orange-50 dark:from-yellow-900/20 dark:to-orange-900/20'
    },
    {
      icon: 'ri-search-2-line',
      title: 'Búsqueda Inteligente',
      description: 'Encuentra cualquier archivo por nombre, contenido, fecha o tipo con filtros potentes',
      gradient: 'from-blue-400 to-cyan-500',
      bgColor: 'bg-gradient-to-r from-blue-50 to-cyan-50 dark:from-blue-900/20 dark:to-cyan-900/20'
    },
    {
      icon: 'ri-eye-line',
      title: 'Vista Previa Universal',
      description: 'Previsualiza más de 200 formatos de archivo sin abrirlos: documentos, imágenes, videos, código',
      gradient: 'from-purple-400 to-pink-500',
      bgColor: 'bg-gradient-to-r from-purple-50 to-pink-50 dark:from-purple-900/20 dark:to-pink-900/20'
    },
    {
      icon: 'ri-folder-settings-line',
      title: 'Organización Automática',
      description: 'Etiquetas automáticas, categorización por IA y carpetas inteligentes que se actualizan solas',
      gradient: 'from-green-400 to-emerald-500',
      bgColor: 'bg-gradient-to-r from-green-50 to-emerald-50 dark:from-green-900/20 dark:to-emerald-900/20'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Seguridad Avanzada',
      description: 'Encriptación de archivos, carpetas protegidas con contraseña y respaldo automático en la nube',
      gradient: 'from-red-400 to-orange-500',
      bgColor: 'bg-gradient-to-r from-red-50 to-orange-50 dark:from-red-900/20 dark:to-orange-900/20'
    },
    {
      icon: 'ri-devices-line',
      title: 'Multiplataforma',
      description: 'Sincroniza entre Windows, macOS, iOS y Android con tu cuenta única',
      gradient: 'from-indigo-400 to-violet-500',
      bgColor: 'bg-gradient-to-r from-indigo-50 to-violet-50 dark:from-indigo-900/20 dark:to-violet-900/20'
    }
  ];

  return (
    <section id="caracteristicas" className="py-20 bg-white dark:bg-gray-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center px-4 py-2 bg-blue-100 dark:bg-blue-900 text-blue-800 dark:text-blue-200 rounded-full text-sm font-medium mb-4">
            CARACTERÍSTICAS PREMIUM
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 dark:text-white mb-6">
            Todo lo que necesitas en un solo lugar
          </h2>
          <p className="text-xl text-gray-600 dark:text-gray-300 max-w-3xl mx-auto">
            AbiSoft Explorer combina potencia, elegancia y funcionalidad para transformar completamente tu experiencia de gestión de archivos
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className={`${feature.bgColor} p-8 rounded-2xl border border-gray-200 dark:border-gray-700 hover:shadow-xl transition-all duration-300 group cursor-pointer`}
            >
              <div className={`w-16 h-16 rounded-2xl bg-gradient-to-r ${feature.gradient} flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300`}>
                <i className={`${feature.icon} text-2xl text-white`}></i>
              </div>
              
              <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-4">
                {feature.title}
              </h3>
              
              <p className="text-gray-600 dark:text-gray-300 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>

        {/* CTA Section */}
        <div className="text-center mt-16">
          <p className="text-lg text-gray-600 dark:text-gray-300 mb-6">
            ¿Listo para experimentar el futuro de la gestión de archivos?
          </p>
          <button className="px-8 py-4 bg-gradient-to-r from-blue-600 to-purple-600 text-white text-lg font-semibold rounded-xl hover:from-blue-700 hover:to-purple-700 transition-all transform hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer">
            Probar AbiSoft Explorer Gratis
          </button>
        </div>
      </div>
    </section>
  );
}